import { Box, Typography } from "@mui/material";
import { People } from "@mui/icons-material";

interface ParticipantsListHeaderProps {
  title: string;
}

/**
 * Nagłówek listy zawodników
 * Zgodny z zasadą pojedynczej odpowiedzialności - tylko wyświetlanie nagłówka
 */
export default function ParticipantsListHeader({ title }: ParticipantsListHeaderProps) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2, px: { xs: 2, sm: 3 } }}>
      {/* <People sx={{ color: "#6366f1", fontSize: 20 }} /> */}
      <Typography variant="h5" sx={{ fontWeight: 600, color: "#2f2f2f" }}>
        {title}
      </Typography>
    </Box>
  );
}
